import { Component, OnChanges, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';

@Component({
    selector: 'customize-footer',
    templateUrl: './customize-footer.component.html',
    styleUrl: './customize-footer.component.scss',
    imports: [NgClass]
})
export class CustomizeFooterComponent implements OnChanges {
  customizeFooter: any = {
    hasRrss: false,
    rrss: []
  }
  constructor(private commonUtilsService: CommonUtilsService) { }
  @Input() configureOptions: any;

  ngOnChanges(): void {
    if(this.configureOptions){
      this.configurationCustomizeFooter();
    }
  }

  configurationCustomizeFooter(){
    this.configureRRSS();
    if(this.configureOptions.footerDescription){
      this.configureOptions.footerDescription = this.configureOptions.footerDescription.replace("\n","");
      if(this.configureOptions.footerDescription.indexOf("<a")!== -1){
        this.configureOptions.footerDescription = this.configureOptions.footerDescription.replace(/<a/g,"<a target='_blank' class='common__centinela-footer-legal-container-inner-link' ");
      }
      if(this.configureOptions.footerDescription.indexOf("<p")!== -1){
        this.configureOptions.footerDescription = this.configureOptions.footerDescription.replace(/p>\n<p/g,"p><span> · </span><p")
        this.configureOptions.footerDescription = this.configureOptions.footerDescription.replace(/p><p/g,"p><span> · </span><p")
        // this.configureOptions.footerDescription = this.configureOptions.footerDescription.replace(/<p/g,"<p class='customize-footer__link-page-item'")
      }
    }

    if(this.configureOptions.footerDesignType === 3){
      this.customizeFooter.ratio = this.commonUtilsService.calculeRatio(this.configureOptions.color);
    }
  }

  configureRRSS(){
    let rrssConfigurationList: any = ['linkedin', 'youtube', 'facebook', 'twitter', 'instagram'];
    rrssConfigurationList.forEach((rrssConfiguration: any) => {
      let rrss : any = this.configureOptions[rrssConfiguration];
      if(rrss){
        let link: string = rrss.indexOf('https://') === -1?'https://' + rrss:rrss;
        this.customizeFooter.rrss.push({key: rrssConfiguration, url: link});
        this.customizeFooter.hasRrss = true;
      }
    });
  }
}
